
import React from "react";
import { 
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Award, Heart } from "lucide-react";

interface ConversionCompleteProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const ConversionComplete: React.FC<ConversionCompleteProps> = ({
  open,
  onOpenChange,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md border-heaven-gold/30">
        <DialogHeader className="flex flex-col items-center text-center">
          <Award className="h-12 w-12 text-heaven-gold mb-2" />
          <DialogTitle className="text-xl font-bold text-heaven-dark-gold">Well Done</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4 text-center px-2">
          <p className="font-medium">
            That was powerful.
          </p>
          
          <p>
            You just stayed in the fight—held your ground with truth, responded with grace, 
            and spoke the gospel like someone who actually believes it.
          </p>
          
          <p>
            This may have been training, but the growth was real. The clarity was real. 
            And the boldness you just practiced? That's exactly what the world needs.
          </p>
          
          <p>
            Now take everything you learned here—
            every verse, every objection, every moment of Spirit-led boldness—
            and bring it into real conversations with real people.
          </p>
          
          <div className="py-2">
            <p>There are souls searching for truth.</p>
            <p>There are hearts desperate for hope.</p>
            <p>And there is a Savior who still saves.</p>
          </div>
          
          <p className="font-medium">
            The harvest is ready.
            <br />
            And you're not alone.
          </p>
          
          <p className="font-bold text-heaven-dark-gold flex items-center justify-center">
            <Heart className="h-4 w-4 mr-1 text-heaven-gold" />
            Go share the gospel—with love, conviction, and courage.
          </p>
        </div>
        
        <div className="flex justify-center mt-2">
          <Button
            onClick={() => onOpenChange(false)}
            className="bg-heaven-gold hover:bg-heaven-gold/90 text-white"
          >
            Continue Practicing
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConversionComplete;
